import { useMemo } from 'react';
import dayjs from 'dayjs';

import { CaseLogActions, Channels } from '@bandido/shared/constants';
import { CaseHistoryResponseDto } from '@bandido/shared/dtos';

export interface MessageGroup {
  author: string;
  channel: Channels;
  id: string;
  messages: CaseHistoryResponseDto[];
}

export const useMessageGroups = (messages: CaseHistoryResponseDto[] | undefined): MessageGroup[] =>
  useMemo(() => {
    if (!messages) return [];

    return messages.reduce((acc: MessageGroup[], history) => {
      const { channel, authorFirstName, authorLastName, createdAt, authorId } = history;
      const author = `${authorFirstName || ''} ${authorLastName || ''}`.trim();
      const currentDate = dayjs(createdAt).startOf('day');
      const lastGroup = acc[acc.length - 1];

      if (channel === Channels.CASE_LOG && acc.length === 0) {
        return [...acc, { author, channel, id: authorId, messages: [history] }];
      }

      const isCreateCaseLog =
        lastGroup?.messages[lastGroup?.messages?.length - 1]?.caseLogAction !== CaseLogActions.CREATE;

      if (
        channel === Channels.CASE_LOG &&
        isCreateCaseLog &&
        dayjs(lastGroup?.messages[0]?.createdAt).isSame(currentDate, 'day') &&
        lastGroup?.id === authorId &&
        lastGroup?.channel === Channels.CASE_LOG
      ) {
        lastGroup.messages.push(history);
        return acc;
      }

      return [...acc, { author, id: authorId, channel, messages: [history] }];
    }, []);
  }, [messages]);
